let leaf = {
    mymap: '',
    style: '',
    themeUrl: wpurls.siteUrl,
    png: '',
    pngFocus: '',
    popUpContent: '',
    locations: mapJson,

    init: function () {
        leaf.mymap = L.map('mapid', {
            doubleClickZoom: false
        }).locate({
            setView: true,
            maxZoom: 8,
        });

        setTimeout(function () {
            leaf.mymap.invalidateSize()
        }, 500);

        leaf.style = L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png');
        leaf.mymap.addLayer(leaf.style);

        leaf.png = L.icon({
            iconUrl: `${leaf.themeUrl}/assets/lib/leaflet/marker-unfocus.png`,
        });

        leaf.pngFocus = L.icon({
            iconUrl: `${leaf.themeUrl}/assets/lib/leaflet/marker-focus.png`,
        });

        let boundsArr = [];
        leaf.locations.forEach(location => {
            leaf.showOnMap(location);
            if (location.lat.length > 0 && location.long.length > 0) {
                boundsArr.push([location.lat, location.long]);
            }
        });
        leaf.mymap.fitBounds(boundsArr, {
            padding: [30, 30]
        });
    },

    showOnMap: function (location) {
        leaf.popUpContent = `<div class="popup-map"><span class="bold">${location.title}</span><span>${location.adress}</span><span class="small-margtop"><a class="btn-link" href="${location.url}"><span class="ico-arrow-right" title="Voir le centre ${location.title}">Voir le centre</span></a></span></div>`;

        var newMarker = new L.Marker([location.lat, location.long], {
            icon: leaf.png
        }).addTo(leaf.mymap);

        newMarker.addEventListener('click', (e) => {
            e.target.setIcon(leaf.pngFocus);
        });

        newMarker.bindPopup(leaf.popUpContent);

        newMarker.getPopup().addEventListener('remove', () => {
            newMarker.setIcon(leaf.png);
        });
    },

}

document.addEventListener('DOMContentLoaded', leaf.init);